import React, { useState } from 'react';
import Icon from 'components/icon';
import PropTypes from 'prop-types';
import cn from 'classnames';

const TabsAccordionContent = ({
  className,
  items = [],
  onTabChange = () => {},
  onMobileAccordionPanelToggle = () => {}
}) => {
  const [activeDesktopIndex, setActiveDesktopIndex] = useState(0);
  const [activeMobileIndexes, setActiveMobileIndexes] = useState([]);

  const handleDesktopClick = index => {
    setActiveDesktopIndex(index);
    onTabChange(index);
  };

  const handleMobileClick = index => {
    setActiveMobileIndexes(prev => {
      const newIndexes = prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index];
      onMobileAccordionPanelToggle(newIndexes);
      return newIndexes;
    });
  };

  return items.length > 0 ? (
    <div className={cn('tabs-accordion-content', className)}>
      <div className="tabs-accordion-content__tabs" role="tablist">
        {items.map((item, index) => {
          const isTabActive = activeDesktopIndex === index;
          return (
            <button
              key={index}
              className={cn('tabs-accordion-content__tab', {
                'tabs-accordion-content__tab--active': isTabActive
              })}
              aria-selected={isTabActive}
              aria-controls={`panel-${index}`}
              disabled={isTabActive}
              onClick={() => handleDesktopClick(index)}
              role="tab"
            >
              <span className="tabs-accordion-content__tab-text">
                {item.title}
              </span>
            </button>
          );
        })}
      </div>
      <div className="tabs-accordion-content__panels">
        {items.map((item, index) => {
          const isPanelActive = activeMobileIndexes.includes(index);
          return item.content ? (
            <div key={index} className="tabs-accordion-content__panels-item">
              <button
                className={cn('tabs-accordion-content__mobile-expand-btn', {
                  'tabs-accordion-content__mobile-expand-btn--active': isPanelActive
                })}
                aria-expanded={isPanelActive}
                aria-controls={`panel-${index}`}
                onClick={() => handleMobileClick(index)}
              >
                <h2 className="tabs-accordion-content__mobile-expand-btn-title">
                  {item.title}
                </h2>
                <span className="tabs-accordion-content__mobile-expand-btn-circle">
                  <Icon
                    name={isPanelActive ? 'chevron-up' : 'chevron-down'}
                    className="tabs-accordion-content__mobile-expand-btn-icon"
                  />
                </span>
              </button>
              <div
                className={cn('tabs-accordion-content__panel', {
                  'tabs-accordion-content__panel--active':
                    activeDesktopIndex === index,
                  'tabs-accordion-content__panel--mobile-active': isPanelActive
                })}
                id={`panel-${index}`}
              >
                <div className="tabs-accordion-content__content">
                  {item.content}
                </div>
              </div>
            </div>
          ) : null;
        })}
      </div>
    </div>
  ) : null;
};

TabsAccordionContent.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.node
    })
  ),
  onTabChange: PropTypes.func,
  onMobileAccordionPanelToggle: PropTypes.func
};

TabsAccordionContent.propTypesMeta = 'exclude';

export default TabsAccordionContent;
